/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import memberClient from 'member-api';

const RESOURCE_ROOT_FACADE = 'wallets/';
const RESOURCE_PAGE_ACTION = '/cards';

const addCardToWallet = (wcEnv, jwtToken, contactId, payloadData) => {
    const {
        accountNumber,
        nameOnCreditCard,
        cardType,
        firstTwoDigits,
        lastFourDigits,
        expiryDate,
        sourceID,
    } = payloadData;

    const payload = {
        wallet: {
            cardType,
            payType: 'CC',
            cardHolderName: nameOnCreditCard,
            cardNumber: accountNumber,
            firstTwoDigits,
            lastFourDigits,
            expiryDate,
            status: 'A',
            subsIndicator: 0,
            cryptoFlag: 'AES',
            tokenFlag: 0,
            sourceID,
        },
    };

    const resourcePath = `${RESOURCE_ROOT_FACADE}${contactId}${RESOURCE_PAGE_ACTION}`;

    return memberClient.performPost(wcEnv, resourcePath, jwtToken, payload).then((response) => response);
};

export default addCardToWallet;
